import {ActionReducer, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromCandidate from '../reducers/candidate.reducer';
import {combineReducers} from '@ngrx/store';

export interface CandidatesState {
  candidates: fromCandidate.CandidateState;
}

export const reducers: ActionReducerMap<CandidatesState> = {
  candidates: fromCandidate.reducer,
};

export const reducer: ActionReducer<CandidatesState> = combineReducers(reducers);

export const getCandidatesState = createFeatureSelector<CandidatesState>('candidatesFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/store/reducers/index.ts